/* unplugin-vue-components disabled */import { render } from "./VabThemeSetting.vue?vue&type=template&id=21cef8eb&scoped=true&ts=true"
import script from "./VabThemeSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./VabThemeSetting.vue?vue&type=script&lang=ts&setup=true"

import "./VabThemeSetting.vue?vue&type=style&index=0&id=21cef8eb&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./VabThemeSetting.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cef8eb"],['__file',"library/components/VabTheme/components/VabThemeSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21cef8eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21cef8eb', __exports__)) {
    api.reload('21cef8eb', __exports__)
  }
  
  module.hot.accept("./VabThemeSetting.vue?vue&type=template&id=21cef8eb&scoped=true&ts=true", () => {
    api.rerender('21cef8eb', render)
  })

}


export default __exports__